import { createOptionsFrom } from "@/lib/common/Option";

export const SearchOptionsRarityLabels = {
	Token: "Token",
	Basic: "Basic",
	Common: "Common",
	Rare: "Rare",
	SuperRare: "Super Rare",
	Majestic: "Majestic",
	Marvel: "Marvel",
	Legendary: "Legendary",
	Fabled: "Fabled",
	Promo: "Promo"
} as const;

export type SearchOptionsRarity = keyof typeof SearchOptionsRarityLabels;

export const SearchOptionsRarityOptions = createOptionsFrom(SearchOptionsRarityLabels);
